/**
 * Created by luka on 23.02.2018.
 */

import {LOADING_PAUSE_FAILED, PAUSE_LOADING, PAUSE_SUCCESS} from "../actions/types";
export function loadingPauseFailed(state = false, action) {
    switch (action.type) {
        case LOADING_PAUSE_FAILED:
            return action.error;
        default:
            return state;
    }
}
export function pauseLoading(state = false, action) {
    switch (action.type) {
        case PAUSE_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}

export function pauseSuccess(state = {}, action) {
    switch (action.type) {
        case PAUSE_SUCCESS:
            return action.response;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/pause/PauseReducer.js